
	import {
		Component,
		Vue
	} from 'vue-property-decorator';
	import {
		customerOrderStatis
	} from '@/api/statistic'
	import {
		nextDay
	} from "@/utils"

	import PickerDate from '@/components/picker-date.vue';
	import PageFooter from '@/components/page-footer.vue';
	import detailDialog from './detail-dialog.vue';

	@Component({
		name: 'CustomerOrderData',
		components: {
			PickerDate,
			PageFooter,
			detailDialog
		}
	})
	export default class CustomerOrderData extends Vue {
		private defaultAvatar = 'https://cdn2024.shiwuzone.com/routuan/image/20230110-0f54988a-9589-45bc-ad27-844c60e80f36.png';
		private loading = false;
		private list: any = [];
		private pageNo = 1;
		private pageSize = 10;
		private total = 0;
		private keywords = '';
		private isCompany = null;
		private filterTime = '';
		private selectList: any = [{
			value: null,
			label: '全部'
		}, {
			value: true,
			label: '是'
		}, {
			value: false,
			label: '否'
		}];
		
		private visible = false;
		private selected:any = {};

		private mounted() {
			this.initTime();
			this.getList()
		}



		private exportList(){
			let url = location.origin + '/pc/member/customerOrderStatisExport'
			url += '?Keywords=' + encodeURIComponent(this.keywords)
			
			if (this.filterTime) {
				var dt = this.filterTime.split('/');
				url += '&StartTime=' + dt[0]
				if (dt[1]){
					url += '&EndTime=' + nextDay(dt[1],1)
				}
			}
			window.open(url)
		}
		private exportAllMemberOrder(){
			let url = location.origin + '/pc/member/allCustomerOrderTimeStatisExport'
			url += '?Keywords=' + encodeURIComponent(this.keywords)
			
			if (this.filterTime) {
				var dt = this.filterTime.split('/');
				url += '&StartTime=' + dt[0]
				if (dt[1]){
					url += '&EndTime=' + nextDay(dt[1],1)
				}
			}
			window.open(url)
		}
		private initTime(){
			var dt = new Date();
			var year = dt.getFullYear();
			var month = dt.getMonth()+1;
			var day = dt.getDate();
			this.filterTime = [year, month, day].join('-')+'/';
		}

		private changePage(e) {
			this.pageNo = +e;
			this.getList();
		}

		private doSearch() {
			this.pageNo = 1;
			this.getList();
		}

		private clearSearch() {
			this.pageNo = 1;
			this.keywords = '';
			this.initTime();
			this.getList();
		}

		private async getList() {
			let params: any = {
				Skip: (this.pageNo - 1) * this.pageSize,
				Take: this.pageSize,
				Keywords: this.keywords
			}
			if (this.filterTime) {
				var dt = this.filterTime.split('/');
				params.StartTime = dt[0];
				if (dt[1]){
					params.EndTime = nextDay(dt[1],1);
				}else{
					params.EndTime = '';
				}
			}
			this.loading = true;
			try {
				const res: any = await customerOrderStatis(params);
				this.list = res.Result.Results
				this.total = res.Result.Total;
			} catch (e) {
				console.log(e)
			} finally{
				this.loading = false;
			}
		}

		private toDetail(e) {
			// console.log(e)
			this.selected = e;
			this.visible = true;
		}
		
		/**
		 * 导出
		 */
		private exportExcel(){
			var url = location.origin + '/pc/profitStatistic/export?';
			url += 'Keywords=' + this.keywords;
			url += '&IsCompany=' + (this.isCompany===null ? '' : this.isCompany);
			
			
			if (this.filterTime && this.filterTime) {
				var dt = this.filterTime.split('/');
				url += '&StartTime=' + dt[0];
				url += '&EndTime=' + nextDay(dt[1],1);
			}
			
			window.open(url)
			
		}
	}
